export default "__VITE_ASSET__Bdo9CJPi__"